import ArticleStoryElement from "@pages/Article/components/ArticleParagraphElements/storyElement/StoryElement";
import { ArticleParagraphElementsProps } from "@pages/Article/components/ArticleParagraphElements/utils/types";

/**
 * Renders the main content elements of an article, including paragraphs, tags, purchase links, paywall modules, and dynamic ad units.
 *
 * Handles logic for premium content, subscriber access, feature flags, and conditional truncation of article content based on user status and feature toggles.
 * Sanitizes and renders each paragraph, manages display of paywall and purchase components, and injects dynamic ad units as needed.
 */
const ArticleParagraphElements = ({
  body,
  className,
  article,
  adsWrapperClass,
  gsChannels,
  articleIndex,
  paragraphWidth,
  paragraphIndices,
  isFullContent,
}: ArticleParagraphElementsProps) => {
  return (
    <>
      {body.map((content, index) => {
        return (
          <ArticleStoryElement
            key={`article-story-element-${index}`}
            bodyString={content}
            className={className}
            article={article}
            index={index}
            articleIndex={articleIndex}
            adsWrapperClass={adsWrapperClass}
            gsChannels={gsChannels}
            displayReadMoreAndNewsletterSignupForm={
              article.displayReadMoreAndNewsletterSignupForm
            }
            paragraphIndices={paragraphIndices}
            paragraphWidth={paragraphWidth}
            isFullContent={isFullContent}
          />
        );
      })}
    </>
  );
};

export default ArticleParagraphElements;
